module.exports = __webpack_public_path__ + "img/Jump Casting70.d4332ef9.jpg";